/**
 * JS for automatic rotation of Pop-Up BBB reviews.
 */
export function BBBPopUp() {
  const speed = 10000;
  let run;
  let container;

  /**
   * Initializes the BBB pop-up starting the reviews rotation and adding the necessary
   * listeners.
   */
  function init() {
    container = $('.bbb-review ul');

    if (!container.length) {
      return;
    }

    const slides = $('.bbb-container');
    slides.width(container.width());
    container.parent().width(container.width());
    container.width(slides.length * container.width());

    // Start rotation
    run = setInterval(rotate, speed);
    listenForCloseButtonClick();
    listenForContainerHover();
  }

  /**
   * Changes the current visible review for the next on the list.
   */
  function rotate() {
    if (container.is(':animated')) {
      return false;
    }

    const elm = container.find(':first-child').prop('tagName');
    container.find(elm + ':last').after(container.find(elm + ':first'));
    resetSlides();
    container.stop().animate({ display: 'none' }, 4000, () => {
      container.stop().animate(
        {
          bottom: container.height() * -2,
          top: '0',
          display: 'block',
        },
        400,
        () => {}
      );
    });

    return false;
  }

  /**
   * Adjusts the container so that the current review is in the frame.
   */
  function resetSlides() {
    container.css({
      bottom: -1 * container.height(),
      top: 'auto',
    });
  }

  /**
   * Listens for clicks on the close button and hide reviews if the click event occurs.
   */
  function listenForCloseButtonClick() {
    $('.bbb-review ul .close-button').click(() => $('.bbb-review').hide());
  }

  /**
   * Listens for container hover events to stop or resume rotating reviews.
   */
  function listenForContainerHover() {
    container
      .parent()
      .mouseenter(() => clearInterval(run))
      .mouseleave(() => (run = setInterval(rotate, speed)));
  }

  return {
    init,
  };
}

$(document).ready(function () {
  const bbbPopUp = new BBBPopUp();
  bbbPopUp.init();
});
